// cryptoPrice.js
import axios from "axios";
import { toast } from "react-toastify";

const formatToTwoDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
};

export const getCachedBitcoinPrice = async () => {
  const cachedData = localStorage.getItem("bitcoinPriceData");
  const today = new Date().toISOString().split("T")[0];

  if (cachedData) {
    const { price, date } = JSON.parse(cachedData);
    if (date === today) {
      return formatToTwoDecimals(price);
    }
  }

  try {
    const res = await axios.get(
      "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd"
    );
    const rawPrice = res.data.bitcoin.usd;

    const formattedPrice = formatToTwoDecimals(rawPrice);
    localStorage.setItem(
      "bitcoinPriceData",
      JSON.stringify({ price: formattedPrice, date: today })
    );
    return formattedPrice;
  } catch {
    toast.error("Error fetching Bitcoin price");
    return "0.00";
  }
};